module.exports = __webpack_public_path__ + "img/undraw_interview_rmcf.c0a8e7a0.svg";